export default __webpack_public_path__ + "static/media/send.260a2226.svg";